// @flow

const getConfiguration = (props: any) => {
    return {
        enableButtons: false,
    }
}
export default getConfiguration;